import { PropsWithChildren, ReactElement, ReactNode } from "react";

export const CardLayout = ({
  children,
  footer,
  header,
  highlightHeader = false,
  margin = true,
}: PropsWithChildren<{
  footer?: ReactNode;
  header?: ReactNode;
  highlightHeader?: boolean;
  margin?: boolean;
}>): ReactElement => {
  const childrenDiv = margin ? (
    <div className="px-4 py-5 sm:p-6 dark:text-gray-500">{children}</div>
  ) : (
    children
  );

  return (
    <div className="card_icon my-6 divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow-sm dark:border-gray-600 dark:bg-zinc-900">
      {header && (
        <div
          className={`px-4 py-5 text-black sm:px-6 dark:text-white ${highlightHeader ? "dark:bg-zinc-700" : "dark:bg-zinc-900"}`}
        >
          {header}
        </div>
      )}
      {childrenDiv}
      {footer && <div className="px-4 py-4 sm:px-6">{footer}</div>}
    </div>
  );
};
